module.exports = __webpack_public_path__ + "static/img/mneMainImgTwo.e997c95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mneMainImgTwo.png
// module id = RMsT
// module chunks = 1